import { useEffect, useState } from 'react';
import './App.css';
import contract from './contracts/nftMint.json';
import { ethers } from 'ethers';
import axios from "axios";

const pinataApiKey = "d6841432f02ef4c8f9f0";
const pinataSecretApiKey = "ccca7574a3bb04d745a4d4c33a2106a176b82bcbf4e4902733ae26195e4a06a7";
const contractAddress = "0xD149836f2Da4651A6800eEFe75d181e5C6F4f242";
const abi = contract.abi;


function App() {
  const [currentAccount, setCurrentAccount] = useState(null);
  const [walletAddress, setWalletAddress] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [uploading, setUploading] = useState(false);
  const [uploadedUrl, setUploadedUrl] = useState(""); // State for the uploaded URL

  const checkWalletIsConnected = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      console.log("Make sure you have Metamask installed!");
      return;
    } else {
      console.log("Wallet exists! We're ready to go!");
    }

    const accounts = await ethereum.request({ method: 'eth_accounts' });

    if (accounts.length !== 0) {
      const account = accounts[0];
      console.log("Found an authorized account: ", account);
      setCurrentAccount(account);
    } else {
      console.log("No authorized account found");
    }
  };

  const connectWalletHandler = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      alert("Please install Metamask!");
      return;
    }

    try {
      const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
      console.log("Found an account! Address: ", accounts[0]);
      setCurrentAccount(accounts[0]);
      setWalletAddress(accounts[0]);
    } catch (err) {
      console.log(err);
    }
  };

  const handleFileUpload = async () => {
    try {
      setUploading(true);
  
      // Create a FormData object to upload the file
      const formData = new FormData();
      formData.append("file",imageFile);
  
    const response = await axios.post("https://api.pinata.cloud/pinning/pinFileToIPFS", formData, {
      headers: {
        "Content-Type": `multipart/form-data`, // Ensure multipart
        pinata_api_key: pinataApiKey,
        pinata_secret_api_key: pinataSecretApiKey,
      },
    });
  
      const url = `https://gateway.pinata.cloud/ipfs/${response.data.IpfsHash}`;
      setUploadedUrl(url); // Store the uploaded file URL in state
      console.log("File uploaded to Pinata:", url);
  
      setUploading(false);
      alert(`File uploaded successfully! Access it here: ${url}`);
      setImagePreview("");
      setImageFile(null)
      return url;
    } catch (err) {
      console.error("Error uploading file to Pinata:", err);
      setUploading(false);
    }
  };

  const uploadJson = async (file) => {
    try {
      setUploading(true);
  
      // Create a FormData object to upload the file
      const formData = new FormData();
      formData.append("file",file);
  
    const response = await axios.post("https://api.pinata.cloud/pinning/pinFileToIPFS", formData, {
      headers: {
        "Content-Type": `multipart/form-data`, // Ensure multipart
        pinata_api_key: pinataApiKey,
        pinata_secret_api_key: pinataSecretApiKey,
      },
    });
  
      const url = `https://gateway.pinata.cloud/ipfs/${response.data.IpfsHash}`;
      setUploadedUrl(url); // Store the uploaded file URL in state
      console.log("File uploaded to Pinata:", url);
  
      setUploading(false);
      alert(`File uploaded successfully! Access it here: ${url}`);
      return url;
    } catch (err) {
      console.error("Error uploading file to Pinata:", err);
      setUploading(false);
    }
  };
  const mintNftHandler = async () => {
    try {
      if (!uploadedUrl) {
        alert("Please select an image file first!");
        return;
      }

      console.log(uploadedUrl);
      
      const metadata = {
        name: "My Awesome NFT",
        description: "This is my first NFT with an image!",
        image: uploadedUrl,
      };

      const metadataUri = await uploadJson(new Blob([JSON.stringify(metadata)], { type: "application/json" }));
      console.log(metadataUri);
      
      const { ethereum } = window;

      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const nftContract = new ethers.Contract(contractAddress, abi, signer);

        alert("Initialize payment");
        let nftTxn = await nftContract.mintNFT(metadataUri);
        alert("Mining... please wait");
        await nftTxn.wait();
        alert("NFT Minted Successfully!");
      } else {
        alert("Ethereum object does not exist");
      }
    } catch (err) {
      console.log("Error minting NFT: ", err);
    }
  };

  const connectWalletButton = () => {
    return (
      <button onClick={connectWalletHandler} className="cta-button connect-wallet-button">
        Connect Wallet
      </button>
    );
  };

  const mintNftButton = () => {
    return (
      <div>
        <h3 className="text-style">Wallet Address: {walletAddress}</h3>
        <div className="upload-container">
          <label className="text-style">Upload Image : </label>
          <input
           className="cta-button connect-wallet-button"
            type="file"
            accept="image/*"
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                setImageFile(file);
                setImagePreview(URL.createObjectURL(file));
              }
            }}
          />
        </div>
        {imagePreview && <img src={imagePreview} alt="Preview" className="image-preview" />}
        {uploading && <p>Uploading to IPFS...</p>}
        <div>
            <button onClick={handleFileUpload} className="cta-button mint-nft-button upload-btn" disabled={uploading}>
              Upload to IPFS
            </button>
            <button onClick={mintNftHandler} className="cta-button mint-nft-button" disabled={uploading}>
              Mint NFT
            </button>
          </div>
      </div>
    );
  };

  useEffect(() => {
    checkWalletIsConnected();
  }, []);

  return (
    <div className="main-app">
      <h1 className="text-color">NFT Minting</h1>
      <div>{currentAccount ? mintNftButton() : connectWalletButton()}</div>
    </div>
  );
}

export default App;
